comments_handler = {

    properties: {
        wordLimit: 1000
    },

    onLoad: function(){
        var self = this;

    },

    addComment: function(event, id) {
        $('#submit').prop('disabled', true);

        var self = this;
        var underLimit = home_handler.wordCount($('textarea[name=comment]').val()) <= self.properties.wordLimit;


        if (underLimit){
            var formData = {
                'name': home_handler.formatText($('input[name=name]').val()) || 'Anonymous',
                'comment': home_handler.formatText($('textarea[name=comment]').val()),
                'sid': id
            };

            $.ajax({
                type: "POST",
                url: properties.commentsURL,
                crossDomain: false,
                data: formData,
                success: function(json) {
                    $('#submit').prop('disabled', false);
                    if (json.error) {
                        alert('server error');

                    } else {
                        $("#comment-submit").fadeOut('500', function() {
                            $("#comment-submit").remove();
                            comments_handler.getComments(id);
                            $('.comments').addClass('expanded').removeClass('hidden');

                        });
                        // window.location.href = "#/step-three/";
                    }
                },
                error: function(xhr, textStatus, errorThrown) {
                    $('#submit').prop('disabled', false);
                    alert('error');
                }
            });
        }
        else {
            $('#submit').prop('disabled', false);
        }


        event.preventDefault();
    },

    getAllComments: function(eventBus){

        //Set Comments
        $.ajax({
            type: "GET",
            url: properties.commentsURL,
            cache: true,
            dataType: "json",
            success: function(json) {

                if (!json.error) {
                    feedbackData.comments = json;
                }

                if (eventBus){
                    eventBus.dispatch("print");
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });
    },

    getComments: function(id){

        var self = this;
        $('.comments').html('');

        //Set Comments
        $.ajax({
            type: "GET",
            url: properties.commentsURL + '?sid=' + id,
            cache: false,
            dataType: "json",
            success: function(json) {

                if (!json.error) {

                    $.each(json, function(index, value) {
                        $('.comments').append('<p>"'+value.comment+'" - <b>'+value.name+'</b></p>')
                    });

                }
                else {
                    $('.comments').addClass('hidden');
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });

    },

    events: function() {
        var self = this;

    }
}
